// extracted by mini-css-extract-plugin
export default {"container":"yr-z","brandName":"zr-z","productName":"Ar-z","productNamePdpEnhancements":"Br-z","breakLongProductName":"Cr-z"};